export const PHONE = "05309562770";
export const PHONE_FORMATTED = "0530 956 27 70";
export const TEL_LINK = `tel:${PHONE}`;
export const WA_LINK =
  "https://wa.me/905309562770?text=Merhaba,%20Beylikd%C3%BCz%C3%BC%20elektrik%20ustas%C4%B1%20i%C3%A7in%20bilgi%20ve%20servis%20almak%20istiyorum.";
export const waLinkFor = (neighborhood) =>
  `https://wa.me/905309562770?text=${encodeURIComponent(
    `Merhaba, ${neighborhood} bölgesinden arıyorum. Elektrik ustası için bilgi ve servis almak istiyorum.`
  )}`;
export const GOOGLE_MAPS_LINK = "https://share.google/sPN5fFLIPvGYVkwdn";
